export default "__VITE_ASSET__DvH53gj6__"